import { Accordion, AccordionDetails, AccordionSummary, Box, Stack, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { getTicketsusuario } from '../services/apis';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';

const formatoEuro = (valor) => Number(valor || 0).toLocaleString('ca-ES', {
    style: 'currency',
    currency: 'EUR'
});

export const TicketsUsuario = ({ year = new Date().getFullYear() }) => {
    const [loaded, setLoaded] = useState(false);
    const [ticketsUsuario, setTicketsusuario] = useState([]);
    const [ticketsEventos, setTicketsEventos] = useState([]);

    const getToneClass = (cantidad) => {
        if (cantidad < 0) {
            return 'ticket-amount-negative';
        }

        if (cantidad > 0) {
            return 'ticket-amount-positive';
        }

        return 'ticket-amount-neutral';
    };

    const cargarTicketsusuario = async () => {
        try {
            const response = await getTicketsusuario(year);

            if (response.success) {
                setTicketsusuario(response.data);
                setTicketsEventos(response.eventos || []);
                setLoaded(true);
            }
        } catch (error) {
            console.error("Error:", error);
        }
    };

    useEffect(() => {
        setLoaded(false);
        cargarTicketsusuario();
    }, [year]);

    if (!loaded || ticketsUsuario.length === 0) {
        if (!loaded || ticketsEventos.length === 0) return null;
    }

    return (
        <Accordion defaultExpanded elevation={0} className="side-ticket-card side-section-accordion">
            <AccordionSummary expandIcon={<ExpandMoreIcon fontSize="small" />}>
                <Box className="side-info-heading">
                    <ConfirmationNumberIcon fontSize="small" />
                    <Typography className="side-widget-title">
                        Els teus tiquets
                    </Typography>
                </Box>
            </AccordionSummary>

            <AccordionDetails>
                <Stack className="side-ticket-list">
                    {ticketsUsuario.map((info) => (
                        <Box key={info.nombre} className="side-ticket-row">
                            <Box className="side-ticket-icon">
                                <ConfirmationNumberIcon fontSize="small" />
                            </Box>
                            <Box className="side-ticket-copy">
                                <Typography className="side-ticket-name">
                                    {info.nombre}
                                </Typography>
                                <Box className="side-ticket-statuses">
                                    <Typography className="side-ticket-paid">Pagat: <strong>{formatoEuro(info.total_pagado)}</strong></Typography>
                                    {Number(info.total_compensado || 0) > 0 && <Typography className="side-ticket-compensated">Ahorrat: <strong>{formatoEuro(info.total_compensado)}</strong></Typography>}
                                    <Typography className="side-ticket-pending">Pendent: <strong>{formatoEuro(info.total_pendiente)}</strong></Typography>
                                </Box>
                            </Box>
                            <Typography className={`side-ticket-amount ${getToneClass(Number(info.cantidad))}`}>
                                {info.cantidad} <span>{formatoEuro(info.total_euros)}</span>
                            </Typography>
                        </Box>
                    ))}
                </Stack>

                {ticketsEventos.length > 0 && (
                    <Accordion elevation={0} className="side-ticket-events">
                        <AccordionSummary expandIcon={<ExpandMoreIcon fontSize="small" />}>
                            <Typography className="side-ticket-events-title">Tiquets per esdeveniment</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Stack spacing={1}>
                                {Object.values(ticketsEventos.reduce((grupos, ticket) => {
                                    const id = ticket.id_evento;
                                    if (!grupos[id]) grupos[id] = { ...ticket, tickets: [] };
                                    grupos[id].tickets.push(ticket);
                                    return grupos;
                                }, {})).map((evento) => (
                                    <Box key={evento.id_evento} className="side-ticket-event">
                                        <Typography className="side-ticket-name">{evento.evento}</Typography>
                                        <Typography className="side-ticket-event-date">{evento.fecha}</Typography>
                                        {evento.tickets.map((ticket) => (
                                            <Box
                                                key={`${ticket.ticket}-${ticket.pagado}`}
                                                className="side-ticket-event-ticket"
                                                sx={{ bgcolor: Number(ticket.pago_compensado || 0) === 1 ? 'var(--morado-suave, #f3e8ff)' : (Number(ticket.pagado) === 1 ? 'var(--verde)' : 'var(--rojo)'), p: 1, borderRadius: 1, mb: 0.5 }}
                                            >
                                                <Typography>{ticket.ticket} × {ticket.cantidad}</Typography>
                                                <Stack alignItems="flex-end" spacing={0.25}>
                                                    <Typography>{formatoEuro(ticket.total_euros)}</Typography>
                                                    <Typography className={Number(ticket.pago_compensado || 0) === 1 ? 'side-ticket-compensated' : (Number(ticket.pagado) === 1 ? 'side-ticket-paid' : 'side-ticket-pending')}>
                                                        {Number(ticket.pago_compensado || 0) === 1 ? 'Ahorrat' : (Number(ticket.pagado) === 1 ? 'Pagat' : 'Pendent')}
                                                    </Typography>
                                                </Stack>
                                            </Box>
                                        ))}
                                    </Box>
                                ))}
                            </Stack>
                        </AccordionDetails>
                    </Accordion>
                )}
            </AccordionDetails>
        </Accordion>
    );
};
